module.exports = __webpack_public_path__ + "img/nws_logo.464ef9f3.webp";